export const ledgerAppIds = [
  "0Rs7D68eWSYvNx1x", // 生产
  "4hVkLR6xlfA8E1x1", // 测试
  // 'ahzxh0klegv1fzol', // 测试
];
